import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=313c1315&scoped=true"
import script from "./OrganizationManage.vue?vue&type=script&lang=js"
export * from "./OrganizationManage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&id=313c1315&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c1315",
  null
  
)

export default component.exports